import script from "./MarketQuotes.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketQuotes.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__